<template>
<div>
    <img src="@/assets/images/v2/Grupo 23.png" style="width: 180px" alt="" class="mx-auto my-12">
    <div class="" style="border: 0px solid #CE142C">
        <img src="@/assets/images/v2/Header_Web_VotacioEscut.jpg" class="img-fluid mx-auto" alt="">
    </div>

    <div class="container">
        <div class="row">
            <div class="col-md-6 offset-md-3 text-center py-8">
                <h2 class="uppercase text-girona text-3xl font-bold">
                    EL NOU ESCUT EL TRIES TU
                </h2>

                <p class="font-bold mt-3">
                    Per primera vegada en 90 anys d'història els Socis poden triar l'escut del Girona FC. Aquí trobaràs dues opcions basades en les respostes dels Socis en la consulta dels elements i si ets Soci podràs escollir quina és la teva opció preferida.
                </p>

                <div class="block md:hidden">
                    <img src="@/assets/images/v2/Icon awesome-arrow-alt-circle-down.png" class="img-fluid mx-auto mt-6" alt="">
                </div>
                
            </div>
        </div>
    </div>


    <div class="" style="background-color: #f4f4f4">
        <div class="container">
            <div class="row">
                <div class="col-md-8 offset-md-2 text-center py-16">
                    <h2 class="uppercase text-girona text-2xl font-bold">
                        L’OPINIÓ DEL SOCI
                    </h2>

                    <p class="mt-3">
                        Els Socis van expressar quins eren els elements que creien més representatius i icònics de l’escut del Club, aquí trobareu els resultats:
                    </p>

                </div>
            </div>
            <div class="row py-10 justify-center">

                <div class="col-md-5">
                    <p class="text-girona text-center md:text-left text-xl md:text-lg font-bold mb-3" id="firstGraph">
                        Com puntuen els Socis els elements de l'escut?
                    </p>

                    <div class="row flex items-center my-2">
                        <div class="col-2 text-center pr-0">
                            <img src="@/assets/images/v2/Grupo 43.png" class="img-fluid mx-auto" alt="">
                        </div>
                        <div class="col-10">
                            <lottie :options="banderaLottieOptions" ref='banderaLottie'/>
                        </div>
                    </div>
                    <div class="row flex items-center my-2">
                        <div class="col-2 text-center pr-0">
                            <img src="@/assets/images/v2/Grupo 41.png" class="img-fluid mx-auto" alt="">
                        </div>
                        <div class="col-10">
                            <lottie :options="frangesLottieOptions" ref='aiguesLottie'/>
                        </div>
                    </div>
                    <div class="row flex items-center my-2">
                        <div class="col-2 text-center pr-0">
                            <img src="@/assets/images/v2/Grupo 42.png" class="img-fluid mx-auto" alt="">
                        </div>
                        <div class="col-10">
                            <lottie :options="nomLottieOptions" ref='coronaLottie'/>
                        </div>
                    </div>
                    <div class="row flex items-center my-2">
                        <div class="col-2 text-center pr-0">
                            <img src="@/assets/images/v2/Grupo 27.png" class="img-fluid mx-auto" alt="">
                        </div>
                        <div class="col-10">
                            <lottie :options="aiguesLottieOptions" ref='frangesLottie'/>
                        </div>
                    </div>
                    <div class="row flex items-center my-2">
                        <div class="col-2 text-center pr-0">
                            <img src="@/assets/images/v2/Grupo 31.png" class="img-fluid mx-auto" alt="">
                        </div>
                        <div class="col-10">
                            <lottie :options="coronaLottieOptions" ref='nomLottie'/>
                            <p class="text-sm">
                                * Nota mitjana en base a 10 punts
                            </p>
                        </div>
                    </div>

                </div>

                <div class="col-md-5 offset-md-1 text-right relative">
                    <span class="block text-girona text-center md:text-left text-xl md:text-lg mt-8 md:mt-0 font-bold mb-0" id="secondGraph">
                        De quin color prefereixen la circumferència els Socis?
                    </span>


                    <div class="md:-mr-8 mt-6">
                        <lottie :options="cercleLottieOptions" ref='cercleLottie'/>
                    </div>
                </div>

            </div>

            <div class="row">
                <div class="col-md-4 px-4 md:px-3 offset-md-4 text-center">
                    <router-link to="historia" class="btn btn-danger btn-block bg-girona mt-6 uppercase font-normal text-xl rounded-none mb-12">
                        Coneix la història
                    </router-link>
                </div>
            </div>
        </div>
    </div>


    <div class="container">
        <div class="row">
            <div class="col-md-8 offset-md-2 text-center py-16">
                <h2 class="uppercase text-girona text-2xl font-bold mb-3">
                    LES DUES PROPOSTES
                </h2>
                <p>
                    Després de la primera consulta als Socis, el Club ha dissenyat dos models d’escut que responen al resultats i comentaris rebuts per part dels Socis. Un dels dos dissenys es convertirà en el nou escut del Girona FC a partir de la temporada 2022/23.
                </p>

                <div class="row my-8 relative"> 
                    <div class="col-md-5 text-center">
                        <img src="@/assets/images/v2/OpcioA_600x600.gif" alt="" class="rounded-circle mx-auto">

                        <h3 class="uppercase text-girona text-4xl font-bold my-4">
                            Opció A
                        </h3>
                        <p class="pb-20">
                            Aquesta versió manté l'estructura actual de l'escut, simplifica els elements i suprimeix la corona, que no arriba a tenir una puntuació mínima de 5. El nom del club pren protagonisme i la paraula 'Girona' passa a la part superior mentre que a la inferior s'escriu per primera vegada el nom complet de l'entitat en català.
                        </p>

                        <router-link to="/opcio-a" class="btn btn-danger btn-block bg-girona mt-6 uppercase font-normal text-xl rounded-xl absolute bottom-0 left-0 t-16">
                            Més detalls
                        </router-link>
                    </div>

                    <div class="col-md-5 offset-md-2 text-center">
                        <img src="@/assets/images/v2/OpcioB_600x600.gif" alt="" class="rounded-circle mx-auto">

                        <h3 class="uppercase text-girona text-4xl font-bold my-4">
                            Opció B
                        </h3>
                        <p class="pb-20">
                            Aquesta versió manté els elements actuals però els representa d'una manera moderna i més visual. Les aigües de l'escut prenen protagonisme i dinamisme mentre que la Senyera s'engrandeix i representa una albada, símbol d'una nova etapa. El nom del club pren protagonisme i la paraula 'Girona' passa a la part superior mentre que a la inferior s'escriu per primera vegada el nom complet de l'entitat en català.
                        </p>

                        <router-link to="/opcio-b" class="btn btn-danger btn-block bg-girona mt-6 uppercase font-normal text-xl rounded-xl absolute bottom-0 left-0 t-16">
                            Més detalls
                        </router-link>
                    </div>
                </div>

            </div>
        </div>
    </div>

    <div style="background-color: #f4f4f4">
        <div class="container">
            <div class="row">
                <div class="col-md-4 px-4 md:px-3 offset-md-4 text-center my-12" v-if="isDisabledVote()">
                    <button type="button" disabled class="btn btn-danger btn-block bg-girona uppercase font-normal text-xl rounded-none my-2">
                        Iniciar votació
                    </button>
                    <span class="mb-2 text-girona font-semibold">
                        LA VOTACIÓ HA FINALITZAT
                    </span>
                </div>
                <div class="col-md-4 px-4 md:px-3 offset-md-4 text-center" v-else>
                    <router-link to="login" class="btn btn-danger btn-block bg-girona uppercase font-normal text-xl rounded-none my-12">
                        Iniciar votació
                    </router-link>
                </div>
            </div>
        </div>
    </div>


    <div class="partners bg-girona">
        <div class="container">
            <div class="row">
                <div class="col-md-12 my-3 d-flex justify-content-center align-items-center">
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://gosbi.com/" target="_blank">
                            <img src="@/assets/img/partners/gosbi_white.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://eu.puma.com/es/es/home" target="_blank">
                            <img src="@/assets/img/partners/Logo_Puma.png" class="img-fluid" style="width: 100px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://es.costabrava.org/" target="_blank">
                            <img src="@/assets/img/partners/Logo_CostaBrava.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <!-- <div class="mt-3 text-center">
                        <a href="https://www.factorenergia.com/es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Factorenergia.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div> -->
                </div>
                <div class="col-md-12 d-flex justify-content-center align-items-center">
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.estrelladamm.com/es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_EstrellaDamm.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.caixabank.es/particular/home/particulares_es.html" target="_blank">
                            <img src="@/assets/img/partners/Logo_Caixabank.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 text-center">
                        <a href="https://www.nissan.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Nissan.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>
                    <div class="mt-3 ml-5 text-center">
                        <a href="https://www.medplaya.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_MedPlaya.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                </div>
                <div class="col-md-12 my-3 d-flex justify-content-center align-items-center">
                    <!-- <div class="mt-3 mr-5 text-center">
                        <a href="https://leoboeck.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_LeoBoek.png" class="img-fluid" style="width: 170px;" alt="">
                        </a>
                    </div> -->
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://www.viajeselcorteingles.es/" target="_blank">
                            <img src="@/assets/img/partners/Logo_ECI.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                    <!-- <div class="mt-3 mr-5 text-center">
                        <a href="https://www.besoccer.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_BeSoccer.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div> -->
                    <div class="mt-3 mr-5 text-center">
                        <a href="https://leoboeck.com" target="_blank">
                            <img src="@/assets/img/partners/LeoBoeck_Logo.png" class="img-fluid" style="width: 120px;" alt="">
                        </a>
                    </div>

                    <div class="mt-3 mr-5 text-center">
                        <a href="https://parlem.com/" target="_blank">
                            <img src="@/assets/img/partners/Logo_Parlem.png" class="img-fluid" style="width: 150px;" alt="">
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>

require('@/assets/css/app.css')
require('../bootstrap');
import 'slick-carousel/slick/slick';

import ExampleComponent from './ExampleComponent'
import ElementsComponent from './ElementsComponent'
import MotiusComponent from './MotiusComponent'
import EvolucioComponent from './EvolucioComponent'

import Lottie from './lottie.vue';

import banderaLottie from '@/assets/images/v2/bandera_catalunya.json';
import aiguesLottie from '@/assets/images/v2/aigues.json';
import cercleLottie from '@/assets/images/v2/cercle.json';
import coronaLottie from '@/assets/images/v2/corona.json';
import frangesLottie from '@/assets/images/v2/franges.json';
import nomLottie from '@/assets/images/v2/nom.json';

import moment from 'moment';


var mobile = require('is-mobile');

export default {
    data() {
        return {
            banderaLottieOptions: {
                animationData: banderaLottie,
                loop: false,
                autoplay: false,
            },
            aiguesLottieOptions: {
                animationData: aiguesLottie,
                loop: false,
                autoplay: false,
            },
            coronaLottieOptions: {
                animationData: coronaLottie,
                loop: false,
                autoplay: false,
            },
            frangesLottieOptions: {
                animationData: frangesLottie,
                loop: false,
                autoplay: false,
            },
            nomLottieOptions: {
                animationData: nomLottie,
                loop: false,
                autoplay: false,
            },
            cercleLottieOptions: {
                animationData: cercleLottie,
                loop: false,
                autoplay: false,
            },
            isMobile: mobile(),
            now: moment(),
            targetDate: moment("23:59:59 19/09/2021", "HH:mm:ss DD/MM/YYYY"),
        }
    },
    components: {
        ExampleComponent,
        ElementsComponent,
        MotiusComponent,
        EvolucioComponent,
        'lottie': Lottie,
    },
    mounted() {
        var instance = this
        window.Popper = require('popper.js').default;
        window.$ = window.jQuery = require('jquery');

        (function ($) {

            "use strict";

            $(document).ready(function () {

                setTimeout(() => {
                    $('#evolucio-slider').slick({
                        centerMode: true,
                        slidesToScroll: 1,
                        centerPadding: '20px',
                        slidesToShow: 3,
                        adaptiveHeight: false,
                        arrows: true,
                        autoplay: false,
                        cssEase: 'linear',
                        prevArrow: '<button class="slick-prev"> < </button>',
                        nextArrow: '<button class="slick-next"> > </button>',
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false,
                                    centerMode: true,
                                    centerPadding: '90px',
                                    slidesToShow: 1
                                }
                            },
                        ]
                    });
                    $('#motius-slider').slick({
                        slidesToShow: 1,
                        autoplay: false,
                        dots: true,
                        arrows: false
                    });
                }, 200);


            });


        })(jQuery);

        if(this.isMobile) {
            document.addEventListener('scroll', function () {
    
                if(instance.isInViewport(document.querySelector('#firstGraph'))) {
                    instance.$refs.banderaLottie.anim.play()
                    instance.$refs.aiguesLottie.anim.play()
                    instance.$refs.coronaLottie.anim.play()
                    instance.$refs.frangesLottie.anim.play()
                    instance.$refs.nomLottie.anim.play()
                }
                if(instance.isInViewport(document.querySelector('#secondGraph'))) {
                    instance.$refs.cercleLottie.anim.play()
                }
    
            }, {
                passive: true
            });
        } else {

            setTimeout(() => {
                instance.$refs.banderaLottie.anim.play()
                instance.$refs.aiguesLottie.anim.play()
                instance.$refs.coronaLottie.anim.play()
                instance.$refs.frangesLottie.anim.play()
                instance.$refs.nomLottie.anim.play()
                instance.$refs.cercleLottie.anim.play()
            }, 1000);
        }



    },
    methods: {
        isUserFromApp() {
            var url_string = window.location.href
            var url = new URL(url_string);
            var c = url.searchParams.get("fromapp");
            
            return c == 1 ? true : false
        },
        isInViewport(el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)

            );
        },
        isDisabledVote() {
            return false
            return this.now.isSameOrAfter(this.targetDate)
        }
    }
}
</script>
